import { ReactText } from 'react'
import { observer } from 'mobx-react-lite'
import { ReactComponent as BellIcon } from 'assets/icons/notificationsBell.svg'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Menu } from 'components/Menu/Menu'
import { Item } from '@react-stately/collections'
import Styles from './OptionsDropdown.module.scss'
import { useRootStore } from 'stores/RootStore'
import { useOpenSettings } from 'hooks/useOpenSettings'
import { SettingScreen } from 'components/Settings/types'
import { BellInactive, MoreDots } from 'blaze-ui/icons'
import { Settings } from 'almanac-ui/icons'
import { IconButton } from 'blaze-ui/IconButton/IconButton'

interface Props {
  onClose: () => void
}

export const OptionsDropdown = observer(({ onClose }: Props) => {
  const { notifications } = useRootStore()
  const { openSettings } = useOpenSettings()

  const handleAction = (action: ReactText) => {
    switch (action) {
      case 'mute':
        notifications.toggleMute()
        break
      case 'settings':
        openSettings(SettingScreen.Notifications)
        break
    }

    onClose()
  }

  return (
    <MenuTrigger placement="bottom-end" popoverClassName={Styles.popover}>
      <IconButton variant="editor" size="sm" icon={MoreDots} aria-label="Menu" />
      <Menu aria-label="Menu" onAction={handleAction}>
        {notifications.mutedAt ? (
          <Item key="mute" textValue="Do not disturb">
            <BellIcon />
            <span className={Styles.label}>Turn on notifications</span>
          </Item>
        ) : (
          <Item key="mute" textValue="Do not disturb">
            <BellInactive />
            <span className={Styles.label}>Do not disturb</span>
          </Item>
        )}
        <Item key="settings" textValue="SettingsTab">
          <Settings />
          <span className={Styles.label}>Settings</span>
        </Item>
      </Menu>
    </MenuTrigger>
  )
})
